/* unplugin-vue-components disabled */import { render } from "./CourseCard.vue?vue&type=template&id=48b1690a&scoped=true"
import script from "./CourseCard.vue?vue&type=script&lang=js"
export * from "./CourseCard.vue?vue&type=script&lang=js"

import "./CourseCard.vue?vue&type=style&index=0&id=48b1690a&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上海杉达-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b1690a"]])

export default __exports__